/**
 * @generated SignedSource<<853a0f63db185be36d938def08b95ccc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AIStudioTaskState = "COMPLETED" | "ERROR" | "NO_CREDITS" | "PROCESSING" | "WAITING";
export type SideGeneratorInput = {
  aspectRatio?: string | null;
  layoutMode?: string | null;
  model?: string | null;
  prompt: string;
  sideImageUrl?: string | null;
  sideImageUrls?: ReadonlyArray<string> | null;
};
export type sideGeneratorStartMutation$variables = {
  input: SideGeneratorInput;
};
export type sideGeneratorStartMutation$data = {
  readonly startSideGenerator: {
    readonly state: AIStudioTaskState;
    readonly taskId: number;
  };
};
export type sideGeneratorStartMutation = {
  response: sideGeneratorStartMutation$data;
  variables: sideGeneratorStartMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SideGeneratorTask",
    "kind": "LinkedField",
    "name": "startSideGenerator",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sideGeneratorStartMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "sideGeneratorStartMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "7f71fcca2e4722d9509fe1e20bb69c27",
    "id": null,
    "metadata": {},
    "name": "sideGeneratorStartMutation",
    "operationKind": "mutation",
    "text": "mutation sideGeneratorStartMutation(\n  $input: SideGeneratorInput!\n) {\n  startSideGenerator(input: $input) {\n    taskId\n    state\n  }\n}\n"
  }
};
})();

(node as any).hash = "44d138b5970f769006d52c7f0b1d1bd5";

export default node;
